import axios from "axios"
import VueCookie from "vue-cookie"
import { constants } from "@/config/constants"

let apiUrl = constants.API_URL
let org = VueCookie.get(`__kursweblara_organisation`)
let token = null

if(org) {
  org = JSON.parse(org)
  if(org.checklist_api_token) {
    token = org.checklist_api_token
  }
}

const api = axios.create({
  baseURL: apiUrl,
  headers: {
    common: {
      Authorization: `Bearer ${VueCookie.get("__kursweblara_access_token")}`
    }
  }
})
const checklistApi = axios.create({
  baseURL: process.env.VUE_APP_APP_CHECKLIST_URL,
  headers: {
    common: {
      "X-AccessToken": token,
      "X-Auth-Token": constants.CHECKLIST_X_AUTH_TOKEN
    }
  }
})
// eslint-disable-next-line
const document_url = process.env.VUE_APP_APP_CHECKLIST_URL.replace("api/", "")
// eslint-disable-next-line
export { api, checklistApi, document_url }
